import React from "react";
import { Check, Loader2, AlertCircle } from "lucide-react";

/**
 * AutosaveIndicator — chip discreto que refleja el estado del auto-guardado.
 * Reutilizable en cualquier formulario del ecosistema.
 * Alineado con Etapa 3 §6.9 (regla UX crítica de auto-guardado).
 *
 * @param {'idle'|'saving'|'saved'|'error'} state
 * @param {Date|null} lastSavedAt
 */
export function AutosaveIndicator({ state = "idle", lastSavedAt = null, testid = "autosave-indicator" }) {
  const isSilent = state === "idle" && !lastSavedAt;

  const meta = {
    saving: {
      icon: <Loader2 size={14} className="animate-spin" />,
      text: "Guardando…",
      cls: "text-slate-500 bg-slate-50 border-slate-200",
    },
    saved: {
      icon: <Check size={14} />,
      text: lastSavedAt ? `Guardado ${formatRel(lastSavedAt)}` : "Guardado",
      cls: "text-emerald-700 bg-emerald-50 border-emerald-200",
    },
    error: {
      icon: <AlertCircle size={14} />,
      text: "No se pudo guardar",
      cls: "text-rose-700 bg-rose-50 border-rose-200",
    },
    idle: {
      icon: <Check size={14} />,
      text: lastSavedAt ? `Guardado ${formatRel(lastSavedAt)}` : "Listo para editar",
      cls: "text-slate-500 bg-slate-50 border-slate-200",
    },
  }[state];

  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${meta.cls} ${isSilent ? "opacity-0" : ""}`}
      data-testid={testid}
      aria-live="polite"
      aria-hidden={isSilent}
    >
      {meta.icon}
      <span>{meta.text}</span>
    </div>
  );
}

function formatRel(date) {
  const s = Math.max(1, Math.floor((Date.now() - date.getTime()) / 1000));
  if (s < 60) return `hace ${s} s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `hace ${m} min`;
  return `a las ${date.toLocaleTimeString("es-PE", { hour: "2-digit", minute: "2-digit" })}`;
}

export default AutosaveIndicator;
